import {Injectable} from '@angular/core';
import {Product} from '@spartacus/core';
import {BehaviorSubject, Observable, ReplaySubject, Subject} from 'rxjs';
import {DcpProductService} from '../../services/dcp-product.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {PRODUCT_SEARCH_FIELDS, VARIANT_PRODUCT_SEARCH_FIELDS} from '@app/config/ProductSearchFieldsConfig';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ConfiguratorProductService {
  private variantProduct$: Subject<Product> = new ReplaySubject<Product>(1);
  private variantProductLoaded$: Subject<boolean> = new BehaviorSubject<boolean>(false);

  private displayProduct$: Subject<Product> = new ReplaySubject<Product>(1);
  private displayProductLoaded$: Subject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private dcpProductService: DcpProductService) {}

  getDisplay$(): Observable<Product> {
    return this.displayProduct$.asObservable();
  }

  getVariant$(): Observable<Product> {
    return this.variantProduct$.asObservable();
  }

  isDisplayProductLoaded$(): Observable<boolean> {
    return this.displayProductLoaded$.asObservable();
  }

  isVariantProductLoaded$(): Observable<boolean> {
    return this.variantProductLoaded$.asObservable();
  }

  setDisplayProduct(displayCode: string) {
    this.displayProductLoaded$.next(false);
    this.fetchDisplayProduct(displayCode);
  }

  setVariantProduct(variantCode: string) {
    this.variantProductLoaded$.next(false);
    this.fetchVariantProduct(variantCode);
  }

  setExistingVariantProduct(product: Product) {
    if (!product) {
      return;
    }
    this.variantProduct$.next(product);
    this.variantProductLoaded$.next(true);
  }

  resetVariantProductSubject(): void {
    this.variantProduct$ = new ReplaySubject(1);
  }

  private fetchDisplayProduct(code: string) {
    this.dcpProductService
      .searchForProduct(code, PRODUCT_SEARCH_FIELDS)
      .pipe(untilDestroyed(this))
      .subscribe((product: Product) => {
        this.displayProduct$.next(product);
        this.displayProductLoaded$.next(true);
      });
  }

  private fetchVariantProduct(code: string) {
    this.dcpProductService
      .searchForProduct(code, VARIANT_PRODUCT_SEARCH_FIELDS)
      .pipe(untilDestroyed(this))
      .subscribe((product: Product) => {
        this.setExistingVariantProduct(product);
      });
  }
}
